<div class="stable-height background">
  <div class="container d-flex flex-md-row flex-column">
    <div class="col text-background p-4 content-container">
      <div class="row mb-4 mb-sm-2 mt-4">
        <div class="col-12 d-inline-block d-flex flex-column choose-plan-title-wrapper">
          <h2 class="title">Pet protection in your pocket</h2>
        </div>
      </div>
      <p>
        The <b>fastest</b>  way to be reunited with your pet. Instantly report your pet lost or stolen and keep your contact details up to date. </p>
      <p>Join <b>10,000+</b> pet keepers keeping their pet safe with our <b>essential</b> pet protection app. </p>
      <div class="download-container">
        <a href="https://apps.apple.com/us/app/identi/id6472050366 /" target="_blank">
          <img class="download-img" src="assets/images/home/app-store.svg" alt="app-store" />
        </a>
      </div>
    </div>
    <div class="image-container">
      <img
        src="/assets/images/home/iOS-Android-banner.png"
        alt="carousel slide 2"
        class="slide-image"
      />
    </div>
  </div>
</div>
